import React from 'react';
import { connect } from 'react-redux';
import actions from './../actions/small-card-actions';


/**
 * Resizer component
 * @class
 */
class Resizer extends React.Component {
  constructor(props) {
    super(props);

    /**
     * Component display name used by React
     */
    this.displayName = 'Resizer';


    /**
     * Whether the window has been resized yet, mainly for unit testing
     */
    this.windowResized = false;


    // bind functions to component
    this.onResize = this.onResize.bind(this);
  }


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    if (!this.props.touch) {
      window.addEventListener('resize', this.onResize);
    } else {
      window.addEventListener('orientationchange', this.onResize);
    }

    // small delay so any components mounted before this one will still get
    // the correct initial window size
    setTimeout(this.onResize, 10);
  }


  /**
   * Called before component is removed from DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('orientationchange', this.onResize);
  }


  /**
   * Called when the browser is resized
   * @returns {undefined} undefined
   */
  onResize() {
    this.props.dispatch(actions.setWindowSize());

    this.windowResized = true;
  }


  /**
   * Renders component
   * @returns {null} null
   */
  render() {
    return null;
  }
}


/**
 * Expected propTypes
 * @prop {Function} dispatch - A Redux function to dispatch events
 * @prop {Boolean} touch - If the browser supports touch events
 */
Resizer.propTypes = {
  dispatch: React.PropTypes.func,
  touch: React.PropTypes.bool,
};


export default connect(({ mediaLabCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState }))(Resizer);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Resizer.jsx
 **/